import { render } from "./DataRemoval.vue?vue&type=template&id=7c4d906a"
import script from "./DataRemoval.vue?vue&type=script&lang=js"
export * from "./DataRemoval.vue?vue&type=script&lang=js"

import "./DataRemoval.vue?vue&type=style&index=0&id=7c4d906a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__